<template>
	<div>
		<b-row>
			<b-col cols="6">
				<b-card class="shadow">
					<highcharts :options="options" style="margin-top: 50px"></highcharts>
				</b-card>
			</b-col>
			<b-col cols="6">
				<b-card class="shadow">
					<div class="card-body pt-0" style="margin-top: 50px">
						<table class="table table-hover table-bordered table-striped mt-3" id="table" >
							<thead>
							<tr>
								<th class="text-center">№</th>
								<th class="text-center">{{ $t("sale.shopName") }}</th>
								<th class="text-center">{{ $t("sale.saleDate") }}</th>
								<th class="text-center">{{ $t("sale.saleNumber") }}</th>
								<th class="text-center">{{ $t("pos.sum") }}</th>
								<th class="text-center">{{ $t("sale.sum-skidka") }}</th>
								<th class="text-center">{{ $t("Оплата") }}</th>
							</tr>
							</thead>
							<tbody>
							<tr v-for="(item, index) in items.items" :key="`sale-items-${index}`">
								<td class="text-center">{{ paginate(index, payload.page, payload.limit) }}</td>
								<td class="text-center">{{ item.shopName }}</td>
								<td class="text-center">{{ item.saleDate }}</td>
								<td class="text-center">{{ item.saleNumber }}</td>
								<td class="text-center">{{ item.amountOfPaymentUzs }}</td>
								<td class="text-center">{{ item.amountOfAfterPromoUzs }}</td>
								<td class="text-center">
									<strong v-for="(i) in item.paymentMap.CASH">
										{{ i.value }} {{ i.currencyCode }} <br>
									</strong>
									<strong v-for="(i) in item.paymentMap.BANK_CARD">
										<p style="color: #4DBD74">{{ i.paymentTypeCode }}</p> {{ i.value }}
										{{ i.currencyCode }}
										<br>
									</strong>
								</td>
							</tr>
							</tbody>
						</table>
						<nav>
							<b-pagination :total-rows="items.total" :per-page="payload.limit" v-model="payload.page"
										  aria-controls="table"/>
						</nav>
					</div>
				</b-card>
			</b-col>
		</b-row>
	</div>
</template>
<script>
import {Chart} from 'highcharts-vue'
import ReportService from "@/views/analytics/otchot/report.service";
import RefundService from "@/services/refund.service";
import {VBTable} from "bootstrap-vue";

export default {
	name: "cashiers",
	components: {
		highcharts: Chart,
		VBTable
	},
	data() {
		return {
			list: [],
			endDateDep:null,
			startDateDep:null,
			items: [],
			payload: {
				page: 1,
				limit: 10,
				keyword: '',
				sort: {
					saleDate: "",
					saleNumber: ""
				}
			}
		}
	},
	computed: {
		optionsList() {
			let a = []
			if (a.length === 0) {
				let obj = {}
				for (const aKey in this.list) {
					obj.name = this.list[aKey].fullName
					obj.y = this.list[aKey].value
					a.push(obj)
					obj = {}
				}
				return a
			}
		},
		options() {
			return {
				chart: {
					plotBackgroundColor: null,
					plotBorderWidth: null,
					plotShadow: false,
					type: 'pie'
				},
				title: {
					text: 'Топ кассиры',
					align: 'center'
				},
				tooltip: {
					pointFormat: '{series.name}: <b>{point.y}.00</b>'
				},
				// accessibility: {
				// 	point: {
				// 		valueSuffix: '%'
				// 	}
				// },
				plotOptions: {
					pie: {
						allowPointSelect: true,
						cursor: 'pointer',
						dataLabels: {
							enabled: true,
							format: '<b>{point.name}</b>: {point.y}.00',
							connectorColor: 'silver'
						}
					}
				},
				series: [{
					name: '',
					data: this.optionsList
				}]
			}
		},
	},
	methods: {
		makeCurrentDateTime() {
			let now = new Date();
			let year = now.getFullYear();
			let month = now.getMonth() + 1;
			let day = now.getDate();
			let hour = now.getHours();
			let minute = now.getMinutes();
			let second = now.getSeconds();
			if (month.toString().length == 1) {
				month = "0" + month;
			}
			if (day.toString().length == 1) {
				day = "0" + day;
			}
			if (hour.toString().length == 1) {
				hour = "0" + hour;
			}
			if (minute.toString().length == 1) {
				minute = "0" + minute;
			}
			if (second.toString().length == 1) {
				second = "0" + second;
			}
			this.date = day + "-" + month + "-" + year;
			this.endDate = day + "-" + month + "-" + year;
			this.startDate = '01' + "-" + month + "-" + year;
			this.endDateDep = day + "-" + month + "-" + year;
			this.startDateDep = '01' + "-" + month + "-" + year;
		},
		async getList() {
			await RefundService.getSaleList(this.payload).then(res => {
				this.items = res.data
			})
		},
		paginate(index, page_size, page_number) {
			--page_size;
			return (page_number * page_size) + index + 1;
		},
		casherList() {
			ReportService.getTopEmployees({startDate: this.startDate, endDate: this.endDate}).then(res => {
				this.list = res.data
			})
		},
	},
	mounted() {

	},
	created() {
		this.makeCurrentDateTime()
		this.getList()
		this.casherList()

	}
}
</script>


<style scoped>

</style>
